import { createContext } from "react";
import GlobalAuthenticatedContextModel from "./GlobalAuthenticatedContextModel";

const GlobalAuthenticatedContext = createContext(GlobalAuthenticatedContextModel);
export default GlobalAuthenticatedContext;